import * as React from 'react';
import { Text, theme } from 'components';
import { Color, Text as NewText } from '@bb/elements-web-rebranding';
import { featureEnabled } from 'utils';

type CalendarSyncButtonProps = {
  isAlmanacAuthenticated: boolean;
  isSyncButtonClicked: boolean;
  existingAlmanacEvent: boolean;
  startOauth: () => void;
  onCalendarSyncButtonClick: () => void;
  newDetailsPageDesign?: boolean;
};

const CalendarSyncButton: React.FunctionComponent<CalendarSyncButtonProps> = ({
  isAlmanacAuthenticated,
  isSyncButtonClicked,
  existingAlmanacEvent,
  startOauth,
  onCalendarSyncButtonClick,
  newDetailsPageDesign,
}) => {
  const hasSupraRebrandingFeature = featureEnabled('supraRebrandingFeature', 1);
  if (existingAlmanacEvent) {
    if (newDetailsPageDesign) {
      return (
        <div className="calendar-sync-success m-y-xs">
          {hasSupraRebrandingFeature ? (
            <NewText color="primary">Added to Calendar</NewText>
          ) : (
            <Text type="secondary">Added to Calendar</Text>
          )}
        </div>
      );
    }
    return (
      <div className="calendar-sync-success m-y-xs">
        <i className="fa fa-calendar-plus-o"></i>{' '}
        <strong>Added to Calendar</strong>
      </div>
    );
  }

  if (isAlmanacAuthenticated) {
    if (isSyncButtonClicked) {
      return (
        <button className="btn btn-info btn-sm m-b-xs col-xs-12" disabled>
          <i className="fa fa-spinner fa-spin"></i>
        </button>
      );
    }
    if (newDetailsPageDesign) {
      return (
        <button
          style={{
            color: hasSupraRebrandingFeature ? Color.PRIMARY : theme.blue6,
          }}
          onClick={() => onCalendarSyncButtonClick()}
        >
          Add to Calendar
        </button>
      );
    }
    return (
      <button
        onClick={() => onCalendarSyncButtonClick()}
        className="btn btn-info btn-sm m-b-xs col-xs-12"
      >
        <i className="fa fa-calendar-plus-o"></i> Add to Calendar
      </button>
    );
  }

  return hasSupraRebrandingFeature ? (
    <a onClick={() => startOauth()}>
      <NewText color="primary" size="large">
        Add to Calendar
      </NewText>
    </a>
  ) : (
    <a
      onClick={() => startOauth()}
      className="btn btn-info btn-sm m-b-xs col-xs-12"
    >
      {!newDetailsPageDesign && <i className="fa fa-calendar-plus-o"></i>}
      Add to Calendar
    </a>
  );
};

export default CalendarSyncButton;
